import { codespaceApi } from 'Services/ControlDataManagement/Features/Codespace/codespaceApi'
import { refundCodeApi } from 'Services/ControlDataManagement/Features/RefundCode/refundCodeApi'
import { zoneApi } from 'Services/ControlDataManagement/Features/Zone/zoneApi'
import { authorityApi } from 'Services/common/Features/Authority/authorityApi'
import userReducer from 'Services/common/Features/User/userSlice'
import allowedClientReducer from 'Services/ProductManagement/Features/AllowedClient/allowedClientSlice'
import { catalogApi } from 'Services/ProductManagement/Features/Catalog/catalogApi'
import { parameterApi } from 'Services/ProductManagement/Features/Parameter/parameterApi'
import productReducer from 'Services/ProductManagement/Features/Product/productSlice'
import { salesRuleApi } from 'Services/ProductManagement/Features/SalesRule/salesRuleApi'
import tariffReducer from 'Services/ProductManagement/Features/Tariff/tariffSlice'
import { vatDefinitionApi } from 'Services/ProductManagement/Features/VATDefinition/vatDefinitionApi'
import { zoneDefinitionApi } from 'Services/ProductManagement/Features/ZoneDefinition/zoneDefinitionApi'
import { affiliateProductApi } from 'Services/SalesManagement/Features/AffiliateProduct/affiliateProductApi'
import affiliateProductReducer from 'Services/SalesManagement/Features/AffiliateProduct/affiliateProductSlice'
import campaignReducer from 'Services/SalesManagement/Features/Campaign/campaignSlice'
import faultReportReducer from 'Services/SalesManagement/Features/FaultReport/faultReportSlice'
import notificationReducer from 'Services/SalesManagement/Features/Notification/notificationSlice'
import { orderApi } from 'Services/SalesManagement/Features/Order/orderApi'
import orderReducer from 'Services/SalesManagement/Features/Order/orderSlice'
import { reportApi } from 'Services/SalesManagement/Features/Report/reportApi'
import reportReducer from 'Services/SalesManagement/Features/Report/reportSlice'
import shortcutReducer from 'Services/SalesManagement/Features/Shortcut/shortcutSlice'
import { salesChannelApi } from 'Services/SalesManagement/Features/TicketSale/salesChannelApi'
import { ticketSaleApi } from 'Services/SalesManagement/Features/TicketSale/ticketSaleApi'
import walttiPosRemoteConfigReducer from 'Services/SalesManagement/Features/WalttiPosRemoteConfig/walttiPosRemoteConfigSlice'
import zoneInfoReducer from 'Services/SalesManagement/Features/ZoneInfo/zoneInfoSlice'
import spmAllowedClientReducer from 'Services/ServiceProviderManagement/Features/AllowedClient/allowedClientSlice'
import deviceReducer from 'Services/ServiceProviderManagement/Features/Device/deviceSlice'
import { salesPointApi } from 'Services/ServiceProviderManagement/Features/SalesPoint/salesPointApi'
import serviceProviderReducer from 'Services/ServiceProviderManagement/Features/ServiceProvider/serviceProviderSlice'
import { combineReducers } from '@reduxjs/toolkit'

const rootReducer = combineReducers({
  user: userReducer,
  order: orderReducer,
  notification: notificationReducer,
  affiliateProduct: affiliateProductReducer,
  report: reportReducer,
  shortcut: shortcutReducer,
  faultReport: faultReportReducer,
  walttiPosRemoteConfig: walttiPosRemoteConfigReducer,
  campaign: campaignReducer,
  zoneInfo: zoneInfoReducer,
  [authorityApi.reducerPath]: authorityApi.reducer,
  [salesChannelApi.reducerPath]: salesChannelApi.reducer,
  [ticketSaleApi.reducerPath]: ticketSaleApi.reducer,
  [reportApi.reducerPath]: reportApi.reducer,
  [orderApi.reducerPath]: orderApi.reducer,
  [affiliateProductApi.reducerPath]: affiliateProductApi.reducer,
  product: productReducer,
  tariff: tariffReducer,
  serviceProvider: serviceProviderReducer,
  device: deviceReducer,
  allowedClient: allowedClientReducer,
  spmAllowedClient: spmAllowedClientReducer,
  [vatDefinitionApi.reducerPath]: vatDefinitionApi.reducer,
  [parameterApi.reducerPath]: parameterApi.reducer,
  [zoneDefinitionApi.reducerPath]: zoneDefinitionApi.reducer,
  [salesRuleApi.reducerPath]: salesRuleApi.reducer,
  [refundCodeApi.reducerPath]: refundCodeApi.reducer,
  [codespaceApi.reducerPath]: codespaceApi.reducer,
  [zoneApi.reducerPath]: zoneApi.reducer,
  [zoneDefinitionApi.reducerPath]: zoneDefinitionApi.reducer,
  [catalogApi.reducerPath]: catalogApi.reducer,
  [salesPointApi.reducerPath]: salesPointApi.reducer
})

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
